import React, { useRef, useState } from "react";

import Swal from "sweetalert2";

import { register } from "../../controllers/UserController";

import getText from "Translator";
import { Link } from "react-router-dom";
import { Button, Card, Grid, TextField } from "@mui/material";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import LoadingOverlay from "react-loading-overlay";

export default function Register(props) {
  const [cellphone, setCellphone] = useState("");
  const [name, setName] = useState("");

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const myRef = useRef(null);
  const { closeSheet, getData, rowsPerPage } = props;
  const [controller] = useMaterialUIController();
  React.useEffect(() => {
    // dispatch({
    //   type: "loading",
    //   payload: { loading: false },
    // });
    // dispatch({
    //   type: "title",
    //   payload: { title: getText("register", controller.lang), subtitle: "" },
    // });
    if (myRef.current !== null) {
      myRef.current.scrollIntoView();
    }
  }, []);

  //#region validationInfo
  let isValid = true;
  let message = "";

  const validationInfo = () => {
    // if (!validator.isEmail(email)) {
    //   isValid = false;
    //   message = message + getText("emailformat", controller.lang) + "<br>";
    // }

    if (cellphone.length < 11) {
      isValid = false;
      message = message + getText("cellformat", controller.lang) + "<br>";
    }

    return isValid;
  };
  //#endregion
  const submitHandler = async () => {
    try {
      if (!validationInfo()) {
        Swal.fire({
          title: "",
          html: message,
          confirmButtonText: getText("ok", controller.lang),
          color: "red",
          icon: "error",
        });
        return;
      }
      // dispatch({
      //   type: "loading",
      //   payload: { loading: true },
      // });
      let newUser = {
        cellphone,
        email,
        userRole: "user",
        name,
        lang: controller.lang,
      };

      let result = await register(controller.lang, newUser);
      if (result.success) {
        Swal.fire({
          title: "",
          text: result.message,
          icon: "success",
          confirmButtonText: getText("ok", controller.lang),
        });
        closeSheet();
        getData(rowsPerPage, 1, "");
        // props.history.push("/main/login");
      } else {
        Swal.fire({
          title: getText("warning", controller.lang),
          text: result.message,
          confirmButtonText: getText("ok", controller.lang),
          icon: "error",
        });
      }
      // dispatch({
      //   type: "loading",
      //   payload: { loading: false },
      // });
    } catch (err) {
      Swal.fire({
        title: "",
        text: getText("warning", controller.lang),
        confirmButtonText: getText("ok", controller.lang),
        icon: "error",
      });
      // dispatch({
      //   type: "loading",
      //   payload: { loading: false },
      // });
    }
  };
  return (
    <MDBox>
      <LoadingOverlay
        active={loading}
        spinner
        text={getText("loading", controller.lang)}
      >
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          style={{ marginRight: "auto", marginLeft: "auto" }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <b>{getText("name", controller.lang)}</b>

            <TextField
              key="name"
              id="name"
              value={name}
              fullWidth={true}
              variant="outlined"
              onChange={(event) => {
                setName(event.target.value);
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              marginTop: 15,
            }}
          >
            <b>شماره موبایل</b>
            {/* <PhoneInput
              country={"us"}
              value={username}
              enableSearch
              onChange={(phone) => setUsername(phone)}
            /> */}
            <TextField
              key="cellphone"
              id="cellphone"
              value={cellphone}
              fullWidth={true}
              variant="outlined"
              onChange={(event) => {
                setCellphone(event.target.value);
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              marginTop: 15,
            }}
          >
            <b>{getText("email", controller.lang)}</b>
            <TextField
              id="email"
              fullWidth={true}
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              variant="outlined"
            />
          </Grid>

          <Grid
            item
            key={"submit"}
            xs={12}
            sm={12}
            md={12}
            style={{
              marginTop: 20,
            }}
          >
            <Button
              color="primary"
              onClick={() => {
                submitHandler();
              }}
              fullWidth={true}
            >
              {getText("submit", controller.lang)}
            </Button>
          </Grid>
        </Grid>
      </LoadingOverlay>
    </MDBox>
  );
}
